import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NotificationService } from 'src/app/core/services/notification.service';
import { EditorResizableOptions } from '@progress/kendo-angular-editor';
import { FrequentlyAskedQuestionsAPIService } from 'src/app/extensions/services/api/faq-api.service';

@Component({
  selector: 'faq-detail',
  templateUrl: './faq-detail.component.html',
  styleUrls: ['./faq-detail.component.scss'],
  standalone: false,
})
export class FrequentlyAskedQuestionsDetailComponent implements OnInit {
  @ViewChild('form') public form: NgForm;

  public props: app.models.DynamicPropsDictionary;
  public isEditorFocused = false;
  public loading: boolean = false;
  public resizable: boolean | EditorResizableOptions = {
    minHeight: 300,
    maxHeight: 800,
  };
  public faq: app.models.FAQModel = {
    question: '',
    answer: '',
  } as app.models.FAQModel;

  constructor(
    private _activatedRoute: ActivatedRoute,
    private _faqAPIService: FrequentlyAskedQuestionsAPIService,
    private _router: Router,
    private _notificationService: NotificationService,
    private _translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.faq.frequentlyAskedQuestionId = this._activatedRoute.snapshot.params['frequentlyAskedQuestionId'];
    if (this.faq.frequentlyAskedQuestionId) {
      this._faqAPIService.getFrequentlyAskedQuestionById(this.faq.frequentlyAskedQuestionId).subscribe(result => {
        this.faq = result.data;
        this.props = result.props;
      });
    }
  }

  redirectFAQManager() {
    this._router.navigate(['faq-manager']);
  }

  saveFAQHandler() {
    if (!this.form.valid) {
      return;
    }
    this.loading = true;
    this._faqAPIService.saveFrequentlyAskedQuestion(this.faq).subscribe(response => {
      if (response.isSuccess) {
        this._notificationService.showSuccess(
          this._translateService.instant('faqManager.notifications.faqSaved'),
          this._translateService.instant('common.success')
        );
        this.form.resetForm();
        this.redirectFAQManager();
      } else {
        this._notificationService.showError(
          this._translateService.instant('faqManager.notifications.faqSaveFailed'),
          this._translateService.instant('common.error')
        );
      }
      this.loading = false;
    });
  }
}
